import { AtIcon } from "../../../../AtIcon";
import { Colors } from "../../../../../../../";
import React from "react";

export const AtTableLoader = (): JSX.Element => (
    <div className="loading">
        <AtIcon icon={["far", "spinner"]} spin size="3x" color={Colors.greyShades.shade7} />
    </div>
);
